import {isFunction} from '@malt/common';
import {initModules} from './init-modules';
import {isJquery} from './is-jquery';
import {getModuleSpecs} from './get-modules-specs';
import {describeDomElement} from './describe-dom-element';
import {ELEMENTS_HAVING_DATA_JSOBJ_EXCLUDING_LATE_INIT, ELEMENTS_HAVING_DATA_JSOBJ_INCLUDING_LATE_INIT} from './selectors';

export function init(element, options = {}) {
    if (isJquery(element)) {
        element.each((i, el) => init(el));
        return;
    }

    let elementsWithModuleSpecs;

    // # Dynamic initialization of a given element
    // Includes elements where data-js-init is defined, since that attribute marks element
    // supposed to be initialized dynamically by calling this function on them.
    // (ex: 'modal-show') is essentially informative for now, to help understand
    // when and by which code the modules will be initialized.
    if (element) {
        // takes care not to initialize elements specifically marked as to be initialized by our "critical" JS code
        const childrenWithModuleSpecs = hasAttribute(element, 'data-critical-only')
            ? []
            : querySelectorAll(ELEMENTS_HAVING_DATA_JSOBJ_INCLUDING_LATE_INIT, element);

        elementsWithModuleSpecs = getModuleSpecs(element) ? [element, ...childrenWithModuleSpecs] : childrenWithModuleSpecs;
    } else {
        // # Regular global initialization
        elementsWithModuleSpecs = querySelectorAll(ELEMENTS_HAVING_DATA_JSOBJ_EXCLUDING_LATE_INIT);
    }

    elementsWithModuleSpecs.forEach((el) => {
        try {
            initModules(el, options.force);
        } catch (err) {
            if (typeof Hop !== 'undefined') {
                Hop.logError(`Could not handle data-jsobj* for element ${describeDomElement(el)}: "${getModuleSpecs(el)}" (see error detail in next log)`);
                Hop.logError(err);
            }
        }
    });
}

function querySelectorAll(selector, root = document) {
    return Array.from(
        root.querySelectorAll(selector),
    );
}

function hasAttribute(el, attributeName) {
    return isFunction(el.hasAttribute) && el.hasAttribute(attributeName);
}
